import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const Team_6 = (props: RealEstateDataPageComponentData) => {
  const { items, title, titleElement, opacityValue, titleColor, image_bottom_gatsby } = props

  const normalizedOpacity = Number(opacityValue) / 100

  const [activeMenus, setActiveMenus] = useState<number[]>([])

  const toggleMenu = (index: number) => {
    setActiveMenus((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    )
  }

  return (
    <section
      id="team"
      className="team-6 p-t-config"
    >
      <Container fluid>
        <Row className="mb-5">
          <Col xs={12}>
            <ElementHTML
              elementType={titleElement ?? 'h1'}
              children={title ?? ''}
              className={`mb-4 text-center`}
              style={titleColor ? { color: titleColor } : {}}
            />
          </Col>
        </Row>
        <Row>
          {items &&
            items.map((teamMember, index) => (
              <Col
                lg={12}
                key={index}
                className="mb-5"
              >
                <div
                  className="position-relative"
                  style={{ overflow: 'hidden' }}
                >
                  <div
                    className={'opacity-background'}
                    style={{
                      backgroundColor: '#6b6b6b6',
                      opacity:
                        opacityValue && opacityValue !== '0'
                          ? Number(opacityValue) !== 100
                            ? normalizedOpacity
                            : 1
                          : 0,
                    }}
                  ></div>
                  <Image
                    className="no-border w-100"
                    objectFit="cover"
                    alt="about-us-img"
                    image={teamMember.image_gatsby!!}
                    hrefImage={teamMember.image}
                    style={{
                      height: '60vh',
                      transition: 'transform 0.3s ease',
                      transform: activeMenus.includes(index) ? 'scale(1.1)' : 'scale(1)',
                    }}
                    objectPosition={'top'}
                  />
                  <div
                    className="d-flex flex-column flex-md-row justify-content-between align-items-center position-absolute bottom-0 start-0 w-100 p-3 pb-1 ps-md-5 pb-md-5"
                    style={{ zIndex: '3' }}
                  >
                    <div
                      style={{
                        opacity: activeMenus.includes(index) ? 0 : 1,
                        visibility: activeMenus.includes(index) ? 'hidden' : 'visible',
                      }}
                      className="title-container text-center text-md-start w-100"
                    >
                      <h1 className="text-white mb-2">{teamMember.title}</h1>
                      <h5 className="text-white">{teamMember.subtitle}</h5>
                    </div>
                    <div
                      className="cursor-pointer mt-3 mt-md-0 me-md-5 text-center"
                      style={{
                        visibility: activeMenus.includes(index) ? 'hidden' : 'visible',
                        maxWidth: '100px',
                      }}
                      onClick={() => toggleMenu(index)}
                    >
                      <GatsbyImage
                        objectFit="cover"
                        alt="arrow-img"
                        image={getImage(image_bottom_gatsby?.url!)!}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      visibility: activeMenus.includes(index) ? 'visible' : 'hidden',
                      opacity: activeMenus.includes(index) ? 1 : 0,
                    }}
                    className="p-5 pb-1 pb-lg-5 menu-container"
                  >
                    <div className="flex-grow-1 overflow-auto">
                      <h2 className="text-white mb-2">{teamMember.title}</h2>
                      <h4 className="text-white">{teamMember.subtitle}</h4>
                      <hr
                        style={{
                          border: 'none',
                          borderTop: '1px solid white',
                        }}
                      />
                      <p style={{ fontWeight: 'bold', color: 'white', marginBottom: '10px' }}>
                        Biografía:
                      </p>
                      <p className="text-white">{teamMember.paragraph}</p>
                      <div className="d-md-none mt-3">
                        <div className="d-flex justify-content-start align-items-center">
                          <p style={{ fontWeight: 'bold', color: 'white', marginBottom: 0 }}>
                            Matrícula:
                          </p>
                          <p className="text-white ps-3">{teamMember.value}</p>
                        </div>
                        <div className="d-flex justify-content-start align-items-center">
                          <p style={{ fontWeight: 'bold', color: 'white', marginBottom: 0 }}>
                            Teléfono:
                          </p>
                          <p className="text-white ps-3">{teamMember.phone}</p>
                        </div>
                        <div className="d-flex justify-content-start align-items-center">
                          <p style={{ fontWeight: 'bold', color: 'white', marginBottom: 0 }}>
                            Mail:
                          </p>
                          <p className="text-white ps-3">{teamMember.email}</p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-between w-100">
                      <div className="d-none d-md-block">
                        <div className="d-flex justify-content-start align-items-center">
                          <p style={{ fontWeight: 'bold', color: 'white', marginBottom: 0 }}>
                            Matrícula:
                          </p>
                          <p className="text-white ps-3">{teamMember.value}</p>
                        </div>
                        <div className="d-flex justify-content-start align-items-center">
                          <p style={{ fontWeight: 'bold', color: 'white', marginBottom: 0 }}>
                            Teléfono:
                          </p>
                          <p className="text-white ps-3">{teamMember.phone}</p>
                        </div>
                        <div className="d-flex justify-content-start align-items-center">
                          <p style={{ fontWeight: 'bold', color: 'white', marginBottom: 0 }}>
                            Mail:
                          </p>
                          <p className="text-white ps-3">{teamMember.email}</p>
                        </div>
                      </div>
                      <div
                        className="cursor-pointer rotated me-md-3 text-center mx-auto mx-md-0 mb-md-0"
                        style={{
                          maxWidth: '100px',
                        }}
                        onClick={() => toggleMenu(index)}
                      >
                        <GatsbyImage
                          objectFit="cover"
                          alt="arrow-img"
                          image={getImage(image_bottom_gatsby?.url!)!}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  )
}

export default Team_6
